import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_examtype,
  add_examtype,
  update_examtype,
  delete_examtype,
  get_examtype_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    examtype: [],
    examtypelist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:""
  },
};

// Async Thunks for API Calls
export const fetchexamtypelist = createAsyncThunk(
    'examtype/fetchexamtypelist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_examtype_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchexamtype = createAsyncThunk(
  "examtype/fetchexamtype",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_examtype(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createexamtype = createAsyncThunk(
  "examtype/createexamtype",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_examtype(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updateexamtype = createAsyncThunk(
  "examtype/updateexamtype",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_examtype(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deleteexamtype = createAsyncThunk(
  "examtype/deleteexamtype",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_examtype({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_category Slice
const examtypeSlice = createSlice({
  name: 'examtypes',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      const { id, name,description } = action.payload;
      state.formData = { id, name,description };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:""
      };
    },
    setexamtype(state, action) {
      state.examtype = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchexamtypelist.fulfilled, (state, action) => {
        state.examtypelist = action.payload.data;
      })
      .addCase(fetchexamtypelist.rejected, (state, action) => {
        state.examtypelist = [];

      })

       // Fetch hostel_category
       .addCase(fetchexamtype.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchexamtype.fulfilled, (state, action) => {
        state.loading = false;
        state.examtype = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchexamtype.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_category
      .addCase(createexamtype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createexamtype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createexamtype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_category
      .addCase(updateexamtype.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updateexamtype.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;
        
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updateexamtype.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_category
      .addCase(deleteexamtype.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteexamtype.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deleteexamtype.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setexamtype,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = examtypeSlice.actions;
export default examtypeSlice.reducer;
